export default __webpack_public_path__ + "static/img13-f533972f13c062e8b94dcaf709538118.webp";